import { makeApiUrl } from '../helpers/makeApiUrl';
import { handleResponse } from '../helpers/handleResponse';
import Cookies from "../helpers/cookies";
import {lStorage, lStorageKeys} from "../helpers/lStorage";

const login = async (hash) => {
    const body = new FormData();
    body.append('hash', hash);
    body.append('apiId', 'ms-zone')

    const requestOptions = {
        method: 'POST',
        body
    }
    return fetch(makeApiUrl('hash-access-tokens', 'v1'), requestOptions)
        .then(handleResponse)
        .then(result => {
            // zapisujemy glowne dane uzytkownika oraz access token
            // wykorzystywany do podtrzymania sesji

            Cookies.set(lStorageKeys.AUTH_USER, JSON.stringify(result.user));
            Cookies.set(lStorageKeys.AUTH_ACCESS_TOKEN, result.accessTokenID);

            // profilaktycznie usuwamy ostatnio przegladane produkty uzytkownika

            lStorage.del(lStorageKeys.LAST_VIEWED_PRODUCTS);

            return result
        })
}

export const hashLoginService = {
    login
};
